import { useCallback, useEffect, useState } from 'react';
import { createDefaultPerformanceContext } from '../components/director/performanceRows';

function useLocationPerformanceContext(locationCode = '') {
  const [performanceContext, setPerformanceContext] = useState(() => ({
    ...createDefaultPerformanceContext(),
    locationCode: locationCode || ''
  }));
  const updatePerformanceContext = useCallback((field, value) => {
    setPerformanceContext((current) => ({
      ...current,
      [field]: value
    }));
  }, []);

  useEffect(() => {
    if (!locationCode) {
      return;
    }

    setPerformanceContext((current) => ({
      ...current,
      locationCode
    }));
  }, [locationCode]);

  return {
    performanceContext,
    setPerformanceContext,
    updatePerformanceContext
  };
}

export default useLocationPerformanceContext;
